import React, {Component} from "react";
import {connect} from "react-redux";
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";
import FJWatermarkView from "../view/FJWatermarkView";
import {FJWatermarkAction} from "../../../redux/action/FJRoot.action";
import FJViewConstant from "../../../constant/FJViewConstant";

class FJResourceWatermarkContainer extends Component{

  _render = () => {
    let {watermarkType, paymentLevel} = this.props;
    let {changeWatermarkTypeAction} = this.props;
    return (
      <FJWatermarkView watermarkType={watermarkType}
                       hasVipTip={paymentLevel === FJViewConstant.USER_PAYMENT_FREE}
                       changeWatermarkTypeAction={changeWatermarkTypeAction}
      />
    );
  };

	render() {
		let {isShow, direction} = this.props;
		return (
      <FJPanelAnimation active={isShow} direction={direction} render={this._render} />
		)
	}

}

const mapStateToProps = function (state) {
	return {
    direction: state.resource.direction,
    watermarkType: state.watermark.watermarkType,
    paymentLevel: state.payment.paymentLevel,
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
    changeWatermarkTypeAction: function (type) {
      dispatch(FJWatermarkAction.changeWatermarkTypeAction(type))
    }
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FJResourceWatermarkContainer);